export default "__VITE_ASSET__CURBboI3__"